$(document).ready(function() {

    $('.toggle').click(function() {

        var modal = $( this ).data( 'modal' );
        var $modal = $("#" + modal);

        // hack: Allow fixed positioning/scrolling 
        // Move the modal out of the card container and attach to the 
        // body in order to allow the modal to float in the center of
        // the user's viewport
        $( 'body' ).append( $modal );

        $modal.toggleClass("active");

    });

});